/**
 * Base error class for all TaskFortress errors
 */
export class TaskFortressError extends Error {
  constructor(message: string) {
    super(message)
    this.name = "TaskFortressError"
  }
}

/**
 * API error class for errors returned by the API
 */
export class ApiError extends TaskFortressError {
  public readonly statusCode: number

  constructor(message: string, statusCode: number = 400) {
    super(message)
    this.name = "ApiError"
    this.statusCode = statusCode
  }
}

/**
 * Network error class for disconnected network
 */
export class NetworkDisconnectedError extends TaskFortressError {
  constructor(message: string = "Network is disconnected") {
    super(message)
    this.name = "NetworkDisconnectedError"
  }
}

/**
 * Validation error class for input validation errors
 */
export class ValidationError extends TaskFortressError {
  constructor(message: string) {
    super(message)
    this.name = "ValidationError"
  }
}

/**
 * Auth error class for authentication errors
 */
export class AuthError extends TaskFortressError {
  constructor(message: string) {
    super(message)
    this.name = "AuthError"
  }
}

/**
 * Crypto error class for cryptography-related errors
 */
export class CryptoError extends TaskFortressError {
  constructor(message: string) {
    super(message)
    this.name = "CryptoError"
  }
}

/**
 * Storage error class for local storage related errors
 */
export class StorageError extends TaskFortressError {
  constructor(message: string) {
    super(message)
    this.name = "StorageError"
  }
}
